// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --section-padding: 7rem;
  --short-form-max-width: 400px;
}

@media (max-width: 767px) {
  :root {
    --section-padding: 5rem;
  }
}

/* Typography */

#participantLogin h1,
#participantLogin h2,
#participantLogin h3 {
  line-height: 1.3;
}

/* Utilities */
.desktop-flex {
  display: flex;
}
.mobile-flex {
  display: none;
}
@media (max-width: 767px) {
  .desktop-flex {
    display: none;
  }
  .mobile-flex {
    display: flex;
  }
}

/* Form elements */
/* TODO change this in design system instead */
#participantLogin label > div {
  margin-bottom: 0.25em !important;
}
.password-mask-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  color: white;
  background: black;
  width: 46px;
  cursor: pointer;
  z-index: 2;
  margin-left: -2px;
  border: 0;
  border-top-right-radius: var(--ce-border-radius-default);
  border-bottom-right-radius: var(--ce-border-radius-default);
}

/* Other shared */

#participantLogin {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#participantLogin main.simple-layout {
  flex: 1;
}

main.simple-layout {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  min-height: calc(100vh - 151px);
}

@media (min-width: 768px) {
  .authentication-action,
  .brand-sidebar {
    width: 50%;
    padding: var(--ce-base-padding-large) var(--ce-base-padding-default);
  }
  .brand-sidebar {
    min-height: calc(100vh - 151px);
  }
}

@media (max-width: 767px) {
  main.simple-layout {
    flex-direction: column-reverse;
  }

  .brand-sidebar {
    width: 100%;
    padding: var(--section-padding) 3rem;
  }

  .authentication-action {
    width: 100%;
    flex: 1;
    padding: var(--ce-base-padding-default) var(--ce-base-padding-large)
      var(--section-padding) var(--ce-base-padding-large);
  }

  .logo-app-icon-desktop {
    display: none;
  }
}

.authentication-action {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.unbranded .authentication-action {
  justify-content: center;
}

.authentication-action .header {
  max-width: var(--short-form-max-width);
  width: 100%;
}

.authentication-action-content {
  max-width: var(--short-form-max-width);
  width: 100%;
  margin-bottom: 40px;
}

.authentication-action-content .login-action {
  background: var(--ce-grey-4);
  border-radius: 10px;
  padding: var(--ce-base-padding-large);
  text-align: center;
}

.authentication-action .project {
  position: relative;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.authentication-action .project-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
}

.authentication-action .projectless-logo {
  width: 200px;
}
.authentication-action .project-logo {
  width: 200px;
  height: auto;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.authentication-action .project-logo img {
  max-height: 100%;
  max-width: 100%;
}

.authentication-action .project-information {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.authentication-action .project-description {
  margin-top: var(--ce-base-padding-default);
}

.authentication-action .project-information .project-name {
  margin-bottom: 0;
  padding-bottom: 0;
}

.authentication-action .project-information .project-organization {
  color: var(--ce-grey-55);
}

@media (max-width: 767px) {
  .authentication-action-content {
    margin-bottom: 0;
  }

  .authentication-action .project-header {
    flex-direction: column;
  }

  .authentication-action .project-logo {
    margin: 0 auto;
  }

  .authentication-action .project-information {
    border-left: none;
    padding-left: 0;
    text-align: center;
  }
}

.logo-header-mobile {
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--ce-blue-vivid-10);
  padding: var(--ce-base-padding-large);
  width: 100%;
}

.logo-header-mobile img {
  margin-bottom: 0;
}

.logo-app-icon {
  max-width: 60%;
  margin-bottom: 21px;
}

@media (max-width: 767px) {
  .logo-header-mobile {
    display: flex;
    background-color: #fff;
    align-self: center;
    justify-content: center;
    padding: var(--section-padding) var(--ce-base-padding-default)
      var(--ce-base-padding-large) var(--ce-base-padding-default);
  }
  .logo-header-mobile-image-wrap {
    width: var(--short-form-max-width);
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .logo-app-icon {
    width: 250px;
    max-width: 100%;
  }
}

/* Try MDHD link */

#content a.try-mdhd {
  text-decoration: none;
  display: flex;
  background: var(--ce-blue-vivid-5);
  align-items: center;
  padding: 13px 15px;
  border-radius: 10px;
  margin-top: 40px;
}

.try-mdhd-logo {
  padding-right: 10px;
}

.try-mdhd-message {
  display: flex;
  flex-direction: column;
  color: var(--ce-blue-vivid-90);
  flex: 1;
  line-height: 1.4;
}

/* Footer */

.authentication-footer {
  background-color: var(--ce-grey-99);
  padding: var(--ce-base-padding-large);
  justify-content: center;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.authentication-footer .footer-content {
  display: flex;
  align-items: center;
  flex-direction: row;
  max-width: 1300px;
  width: 100%;
  justify-content: space-between;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.authentication-action .sub-action {
  margin: var(--ce-body-default) auto var(--ce-base-padding-small) auto;
}

/* Errors */

.server-error,
.client-error-container {
  border-radius: 6px;
  padding: 8px 12px;
}

.server-error {
  color: var(--ce-red-55);
  background: var(--ce-red-2);
  border: 1px solid var(--ce-red-10);
}

.client-error-container {
  background: var(--ce-violet-2);
  border: 1px solid var(--ce-violet-10);
  margin-bottom: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/authentication.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,eAAe;;AAEf;;;EAGE,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB,8CAA8C;AAC9C;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,wDAAwD;EACxD,2DAA2D;AAC7D;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE;;IAEE,UAAU;IACV,oEAAoE;EACtE;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,OAAO;IACP;yDACqD;EACvD;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB;iEAC6D;EAC/D;EACA;IACE,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,kBAAkB;;AAElB;EACE,qBAAqB;EACrB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,OAAO;EACP,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,qEAAqE;AACvE;;AAEA,WAAW;;AAEX;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;AACrB","sourcesContent":["/* Variables */\n:root {\n  --section-padding: 7rem;\n  --short-form-max-width: 400px;\n}\n\n@media (max-width: 767px) {\n  :root {\n    --section-padding: 5rem;\n  }\n}\n\n/* Typography */\n\n#participantLogin h1,\n#participantLogin h2,\n#participantLogin h3 {\n  line-height: 1.3;\n}\n\n/* Utilities */\n.desktop-flex {\n  display: flex;\n}\n.mobile-flex {\n  display: none;\n}\n@media (max-width: 767px) {\n  .desktop-flex {\n    display: none;\n  }\n  .mobile-flex {\n    display: flex;\n  }\n}\n\n/* Form elements */\n/* TODO change this in design system instead */\n#participantLogin label > div {\n  margin-bottom: 0.25em !important;\n}\n.password-mask-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  color: white;\n  background: black;\n  width: 46px;\n  cursor: pointer;\n  z-index: 2;\n  margin-left: -2px;\n  border: 0;\n  border-top-right-radius: var(--ce-border-radius-default);\n  border-bottom-right-radius: var(--ce-border-radius-default);\n}\n\n/* Other shared */\n\n#participantLogin {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n#participantLogin main.simple-layout {\n  flex: 1;\n}\n\nmain.simple-layout {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  min-height: calc(100vh - 151px);\n}\n\n@media (min-width: 768px) {\n  .authentication-action,\n  .brand-sidebar {\n    width: 50%;\n    padding: var(--ce-base-padding-large) var(--ce-base-padding-default);\n  }\n  .brand-sidebar {\n    min-height: calc(100vh - 151px);\n  }\n}\n\n@media (max-width: 767px) {\n  main.simple-layout {\n    flex-direction: column-reverse;\n  }\n\n  .brand-sidebar {\n    width: 100%;\n    padding: var(--section-padding) 3rem;\n  }\n\n  .authentication-action {\n    width: 100%;\n    flex: 1;\n    padding: var(--ce-base-padding-default) var(--ce-base-padding-large)\n      var(--section-padding) var(--ce-base-padding-large);\n  }\n\n  .logo-app-icon-desktop {\n    display: none;\n  }\n}\n\n.authentication-action {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.unbranded .authentication-action {\n  justify-content: center;\n}\n\n.authentication-action .header {\n  max-width: var(--short-form-max-width);\n  width: 100%;\n}\n\n.authentication-action-content {\n  max-width: var(--short-form-max-width);\n  width: 100%;\n  margin-bottom: 40px;\n}\n\n.authentication-action-content .login-action {\n  background: var(--ce-grey-4);\n  border-radius: 10px;\n  padding: var(--ce-base-padding-large);\n  text-align: center;\n}\n\n.authentication-action .project {\n  position: relative;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.authentication-action .project-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 10px;\n}\n\n.authentication-action .projectless-logo {\n  width: 200px;\n}\n.authentication-action .project-logo {\n  width: 200px;\n  height: auto;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.authentication-action .project-logo img {\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.authentication-action .project-information {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.authentication-action .project-description {\n  margin-top: var(--ce-base-padding-default);\n}\n\n.authentication-action .project-information .project-name {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.authentication-action .project-information .project-organization {\n  color: var(--ce-grey-55);\n}\n\n@media (max-width: 767px) {\n  .authentication-action-content {\n    margin-bottom: 0;\n  }\n\n  .authentication-action .project-header {\n    flex-direction: column;\n  }\n\n  .authentication-action .project-logo {\n    margin: 0 auto;\n  }\n\n  .authentication-action .project-information {\n    border-left: none;\n    padding-left: 0;\n    text-align: center;\n  }\n}\n\n.logo-header-mobile {\n  display: none;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--ce-blue-vivid-10);\n  padding: var(--ce-base-padding-large);\n  width: 100%;\n}\n\n.logo-header-mobile img {\n  margin-bottom: 0;\n}\n\n.logo-app-icon {\n  max-width: 60%;\n  margin-bottom: 21px;\n}\n\n@media (max-width: 767px) {\n  .logo-header-mobile {\n    display: flex;\n    background-color: #fff;\n    align-self: center;\n    justify-content: center;\n    padding: var(--section-padding) var(--ce-base-padding-default)\n      var(--ce-base-padding-large) var(--ce-base-padding-default);\n  }\n  .logo-header-mobile-image-wrap {\n    width: var(--short-form-max-width);\n    max-width: 100%;\n    display: flex;\n    justify-content: flex-start;\n  }\n  .logo-app-icon {\n    width: 250px;\n    max-width: 100%;\n  }\n}\n\n/* Try MDHD link */\n\n#content a.try-mdhd {\n  text-decoration: none;\n  display: flex;\n  background: var(--ce-blue-vivid-5);\n  align-items: center;\n  padding: 13px 15px;\n  border-radius: 10px;\n  margin-top: 40px;\n}\n\n.try-mdhd-logo {\n  padding-right: 10px;\n}\n\n.try-mdhd-message {\n  display: flex;\n  flex-direction: column;\n  color: var(--ce-blue-vivid-90);\n  flex: 1;\n  line-height: 1.4;\n}\n\n/* Footer */\n\n.authentication-footer {\n  background-color: var(--ce-grey-99);\n  padding: var(--ce-base-padding-large);\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n\n.authentication-footer .footer-content {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  max-width: 1300px;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.footer-top {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.authentication-action .sub-action {\n  margin: var(--ce-body-default) auto var(--ce-base-padding-small) auto;\n}\n\n/* Errors */\n\n.server-error,\n.client-error-container {\n  border-radius: 6px;\n  padding: 8px 12px;\n}\n\n.server-error {\n  color: var(--ce-red-55);\n  background: var(--ce-red-2);\n  border: 1px solid var(--ce-red-10);\n}\n\n.client-error-container {\n  background: var(--ce-violet-2);\n  border: 1px solid var(--ce-violet-10);\n  margin-bottom: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
